import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    'РВП, ВНЖ, Гражданство РФ',
    'Переводы документов',
    'Полный комплекс услуг',
    'Работаем в Москве и МО'
  ];

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text fade-in-left">
            <h1>
              Профессиональная помощь
              <span className="hero-highlight"> в решении миграционных вопросов</span>
            </h1>
            
            <p className="hero-description">
              РВП, ВНЖ, Гражданство РФ, Переводы — Полный комплекс услуг в 
              Москве и Московской области
            </p>

            <div className="hero-features">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="hero-feature"
                  style={{ animationDelay: `${index * 0.1 + 0.3}s` }}
                >
                  <CheckCircle size={20} className="feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="hero-buttons">
              <button className="btn-primary pulse" onClick={scrollToForm}>
                Оставить заявку
                <ArrowRight size={20} />
              </button>
              
              <a href="#services" className="btn-secondary">
                Наши услуги
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;